module.exports = ".dashboard-nav-link {\n  font-size: 16px;\n  color: #13507e; }\n"